module.exports = __webpack_public_path__ + "static/img/congratulations.b98b89d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/host_activity/congratulations.png
// module id = JzV9
// module chunks = 0